import { FC } from 'react';
import { HeaderEquipmentWidgetProps } from './types';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { Conditional } from '../../common';
import { SelectedEquipment } from './header-selected-equipment';
import { NoSelectedEquipment } from './header-no-selected-equipment';
import { HeaderEquipmentSeparator } from './header-equipment-separator';
import { HeaderEquipmentWidgetLoading } from './header-equipment-widget-loading/HeaderWquipmentWidgetLoading';
import { HeaderEquipmentButton } from './header-equipment-button/header-equipment-button';

export const HeaderEquipmentWidgetButton: FC<HeaderEquipmentWidgetProps> = ({
  label,
  selectedEquipmentInfo = {},
  onClick,
  imgComp,
  subLabel = '',
  isinitialLoading,
  isFeatureFlag = false,
  size,
  tooltipMessage
}) => {
  const hasSelectedEquipment = !!selectedEquipmentInfo?.model;

  const clickHandler = () => {
    if (onClick) {
      onClick(hasSelectedEquipment);
    }
  };
  const isInteractive = isFeatureFlag ? !!hasSelectedEquipment : true;

  return (
    <>
      <HeaderEquipmentSeparator isFeatureFlag={isFeatureFlag} size={size} />
      <Conditional
        test={!isinitialLoading}
        fallback={<HeaderEquipmentWidgetLoading />}
      >
        <Conditional
          test={isFeatureFlag}
          fallback={
            <HeaderEquipmentButton
              clickHandler={clickHandler}
              hasSelectedEquipment={hasSelectedEquipment}
              isFeatureFlag={isFeatureFlag}
              subLabel={subLabel}
              size={size}
            >
              {hasSelectedEquipment ? (
                <SelectedEquipment
                  {...selectedEquipmentInfo}
                  imgComp={imgComp}
                  isFeatureFlag={isFeatureFlag}
                />
              ) : (
                <NoSelectedEquipment
                  label={label}
                  subLabel={subLabel}
                  isFeatureFlag={isFeatureFlag}
                />
              )}
            </HeaderEquipmentButton>
          }
        >
          {hasSelectedEquipment ? (
            <HeaderEquipmentButton
              clickHandler={clickHandler}
              hasSelectedEquipment={hasSelectedEquipment}
              isFeatureFlag={isFeatureFlag}
              subLabel={subLabel}
              size={size}
            >
              <SelectedEquipment
                {...selectedEquipmentInfo}
                imgComp={imgComp}
                isFeatureFlag={isFeatureFlag}
              />
            </HeaderEquipmentButton>
          ) : (
            <CatTooltip
              key={`${isInteractive}`}
              position="bottom"
              isInteractive={isInteractive}
            >
              <HeaderEquipmentButton
                clickHandler={clickHandler}
                hasSelectedEquipment={hasSelectedEquipment}
                isFeatureFlag={isFeatureFlag}
                subLabel={subLabel}
                size={size}
              >
                <NoSelectedEquipment
                  label={label}
                  subLabel={subLabel}
                  isFeatureFlag={isFeatureFlag}
                />
              </HeaderEquipmentButton>
              <CatTextPassage size="xs">{tooltipMessage}</CatTextPassage>
            </CatTooltip>
          )}
        </Conditional>
      </Conditional>
    </>
  );
};
